<app-header [user]="user"></app-header>
<main class="container" style="min-height: 100%;">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
